import { createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/img/logo.png'
import _imports_1 from '../assets/img/logo_en.png'


const _hoisted_1 = { class: "index-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "title" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "bottom" }, [
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createTextVNode("庆祝新中国成立75周年"),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode("用数据洞察中国变革驱动力")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "star" }, [
    /*#__PURE__*/_createVNode("div", { class: "star-item" }),
    /*#__PURE__*/_createVNode("div", { class: "star-item" }),
    /*#__PURE__*/_createVNode("div", { class: "star-item" }),
    /*#__PURE__*/_createVNode("div", { class: "star-item" }),
    /*#__PURE__*/_createVNode("div", { class: "star-item" })
  ]),
  /*#__PURE__*/_createVNode("div", { class: "logo-en" }, [
    /*#__PURE__*/_createVNode("img", {
      src: _imports_1,
      alt: ""
    })
  ]),
  /*#__PURE__*/_createVNode("div", { class: "notice" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4
  ]))
}